<template>

  <v-autocomplete v-model="current"
                  :label="label || 'Sport'"
                  placeholder="Sport"
                  :items="items"
                  item-text="labels.default"
                  item-value="id"
                  :clearable="true"
                  :loading="loading"
                  hide-no-data="hide-no-data"
                  :search-input.sync="search"></v-autocomplete>

</template>

<script>

export default {
  name: 'SportSelector',
  props: ['value', 'item', 'label', 'restrict', 'allEnabled'],
  data () {
    return {
      search: '',
      loading: false,
      items: []
    }
  },
  computed: {
    current: {
      get () {
        // Return the current selected item, or null
        return this.items.find(c => c.id === this.value) || null
      },
      set (c) {
        // Emit the new item id (c is the id, not the item object)
        this.$emit('input', c)
      }
    }
  },
  methods: {
    updateItems () {
      const items = this.$store.state.sports

      // Add a copy of new items if not already listed
      for (const id in items) {
        if (!this.items.find(item => item.id === id)) {
          this.items.push(JSON.parse(JSON.stringify(items[id])))
        }
      }
    }
  },
  watch: {
    search (s) {
      // Reset selection on empty search input
      if (s === '') {
        this.current = null
      }
    },
    '$store.state.sports' () {
      this.updateItems()
    }
  },
  mounted () {
    this.loading = true
    this.$store.dispatch('getSports')
      .catch(err => { console.error('Failed to fetch sports: ', err) })
      .finally(() => { this.loading = false })
    this.updateItems()
  }
}

</script>



// WEBPACK FOOTER //
// src/components/SportSelector.vue